import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';
import { FormControl, Validators } from '@angular/forms';
import { forkJoin, Observable } from 'rxjs';


@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.css']
})
export class KycComponent implements OnInit {

  output:any =[];
  isLoader = false;
  body = true
  deleteId=null
  deleteNo=null

  constructor(private service: ServiceService, private route: ActivatedRoute, private router: Router) {
   
  }



//excel Export For CustomerKyc
  excelExport() {
    var orderTable = document.getElementById('CustomerKyc');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('kyc.' + ('xlsx')));


  }

  DeleteKyc(){
    console.log("this.deleteId",this.deleteId)
       //-------api delete user-------------
    this.service.DeleteKyc(this.deleteId).subscribe((res)=>{
    console.log("res",res)
 
    //------------call api for display the new list-------------
    this.ngOnInit();
     })
  }


  //-----------function for set id of deleting user------------
SetId(Id:any,No:any){
  this.deleteId=Id
  this.deleteNo=No
}

  ngOnInit(): void {

    this.service.listkyc().subscribe((res)=>{
          this.output=res.data
          console.log("data=",this.output)
          console.log("res=",res)         
          })  
    }

  }
